import vue from "@/main.js";
/**
 * 判断运行环境是不是微信浏览器
 */
function isWechat() {
    // 首先判断是否是微信内置浏览器，然后再去判断机型android iOS
    var uExplorer = window.navigator.userAgent.toLowerCase()
    // var uUserAgent = navigator.userAgent
    // var isAndroid = uUserAgent.indexOf('Android')
    // 是微信
    if (uExplorer.match(/MicroMessenger/i) === 'micromessenger') {
        return true;
        // if (isAndroid > -1) {
        // Toast('点击右上角，用浏览器打开进行下载')
        // } else {
        // Toast('请去App Store中进行下载')
        // }
    } else {
        return false;
        // if (isAndroid > -1) {
        // window.location.href = 'https://fir.im/REITsAnd'
        // } else {
            // Toast('请去App Store中进行下载')
        // }
    }
}
const isWechatVar = isWechat();

// 导航栏Mixins
export const navMixins = {
    methods: {
        onGoBack() {
            this.$router.go(-1);
        },
        onGoHome(appLevel) {

            switch(appLevel) {
                case "THIRD_LOW":
                    vue.$router.push("/simple-home");
                    break;
                case "PLATFORM_HIGH":
                    vue.$router.push("/home");
                    break;
                case "NINE_NINE":
                    vue.$router.push("/nine");
                    break;
                case "STARBUCKS":
                    vue.$router.push("/starbucks-home");
                    break;
                case "WECHAT-RED-PACKET":
                    vue.$router.push("/wechat-red-packet");
                    break;
            }
        }
    }
};

// 微信判断Mixins
export const wechatMixins = {
    data() {
        return {
            isWechat: isWechatVar
        };
    }
};
